module.exports = __webpack_public_path__ + "static/img/free.eb878ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/free.png
// module id = pPXG
// module chunks = 216